export default "__VITE_ASSET__CKhUW$eS__";